var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowDown = function SvgIconArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Arrow_down",
    "data-name": "Arrow down",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    strokeWidth: 0
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12166",
    "data-name": "Path 12166",
    d: "M5.645 5.315a.93.93 0 0 1-1.34 0L.19 1.233a.741.741 0 0 1 0-1.044.755.755 0 0 1 1.053 0l3.732 3.7 3.732-3.7a.755.755 0 0 1 1.053 0 .741.741 0 0 1 0 1.044Z",
    transform: "translate(3.025 5.025)",
    fill: "#5b7682"
  })));
};
export { SvgIconArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQXJyb3dfZG93biIgZGF0YS1uYW1lPSJBcnJvdyBkb3duIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiIgc3Ryb2tlLXdpZHRoPSIwIj4KICAgIDxwYXRoIGlkPSJQYXRoXzEyMTY2IiBkYXRhLW5hbWU9IlBhdGggMTIxNjYiCiAgICAgICAgICBkPSJNNS42NDUsNS4zMTVhLjkzLjkzLDAsMCwxLTEuMzQsMEwuMTksMS4yMzNBLjc0MS43NDEsMCwwLDEsLjE5LjE4OWgwYS43NTUuNzU1LDAsMCwxLDEuMDUzLDBsMy43MzIsMy43TDguNzA3LjE4OWEuNzU1Ljc1NSwwLDAsMSwxLjA1MywwaDBhLjc0MS43NDEsMCwwLDEsMCwxLjA0NFoiCiAgICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzLjAyNSA1LjAyNSkiIGZpbGw9IiM1Yjc2ODIiLz4KPC9zdmc+Cg==";